export const SOLICITATION_STATUS = {
  ENVIO_NOTIFICACAO: 'd0ad29e0-58cc-4372-a567-e5a105a6b79f',
};


export const ENVIAR_PARA_ESTOQUE = {
  value: 4,
  name: 'Enviar para estoque',
};

export const BAIXAR_APARELHO = {
  value: 5,
  name: 'Baixar aparelho',
};

export const GROUP_MOVTO_APARELHO = [
  ENVIAR_PARA_ESTOQUE,
  BAIXAR_APARELHO
];

export const PERDA = {
  value: 1,
  name: 'Perda',
};

export const FURTO = {
  value: 2,
  name: 'Furto',
};

export const AVARIA = {
  value: 3,
  name: 'Avaria',
};

export const DOACAO = {
  value: 4,
  name: 'Doação',
};

export const VENDA = {
  value: 5,
  name: 'Venda',
};

export const OBSOLETO = {
  value: 6,
  name: 'Obsoleto',
};

export const DESCARTE = {
  value: 7,
  name: 'Descarte',
};

export const NAO_POSSUI_APARELHO = {
  value: 4,
  name: 'Não possui',
};

export const GROUP_TIPO_BAIXA = [
  PERDA,
  FURTO,
  AVARIA,
  DOACAO,
  VENDA,
  OBSOLETO,
  DESCARTE,
];

export const AUTOMATION_CANCEL_LINE = 5;
export const AUTOMATION_RESET_LINE = 20;
export const AUTOMATION_REACTIVATE_LINE = 10;
export const AUTOMATION_BLOCK_VOICE_DATA_VIVO = 26;

export const CLARO = 1;
export const VIVO = 3;